export default "__VITE_ASSET__37a141f1__"